import React, {Component} from "react";

import SplitIOTreatment from "../../splitio/splitioTreatment";

import GamificationMenu from "./gamification-menu.js";

import NormalTopMenu from "../normal-top-menu/normal-top-menu.js";

require("./gamification-menu.css");

const featureName = "Gamification_by_business_group";

export default class GamificationMenuToggler extends Component {  

   

    render() {
        return (
                <div>
                    <SplitIOTreatment featureName={featureName} treatmentValue="on" trafficType="business-group">
                        {(treatment)=>{
                                if(treatment === "on"){
                                    return(<GamificationMenu {...this.props} />)
                                }
                                else if (treatment === "off") {
                                    return (<NormalTopMenu {...this.props} />);
                                }
                                else {
                                    return null;
                                }
                            }
                        }
                    </SplitIOTreatment>
                </div>
                
        )
      
    }
    // As an alternative you could use our equivalent HOC
}


// WEBPACK FOOTER //
// ./src/components/containers/gamification-menu/gamification-menu-toggler.js